import {action, makeObservable, observable} from "mobx";
import {DayadaRequester} from "./RequestApi/DayadaRequester";

export class DayadaStore {
    currentPatient = {}


    constructor() {
        makeObservable(this, {
            currentPatient: observable,
            setPatient: action,
            updatePatientDetails: action,
            answer: action,
            toggleIrrelevant: action,
            updateInnerComment: action,
            deletePatient: action,
            setCommentFiles: action,
            removeCommentFile: action,
            removeRecommendationFile: action,
            setRecommendationFiles: action,
            updateRecommendationText: action,


        });
    }

    setPatient = async (username) => {
        this.currentPatient = await DayadaRequester.getPatient(username)
    }


    updatePatientDetails = async (patient) => {
        this.currentPatient = await DayadaRequester.updatePatientDetails(patient);
    }

    answer = async (questionIndex, expertAnswers) => {
        this.currentPatient = await DayadaRequester.answer(questionIndex, expertAnswers, this.currentPatient._id);

    }

    toggleIrrelevant = async (questionIndex) => {
        this.currentPatient = await DayadaRequester.toggleIrrelevant(questionIndex, this.currentPatient._id);

    }

    updateInnerComment = async (questionIndex, expertInnerComment) => {
        this.currentPatient = await DayadaRequester.updateInnerComment(questionIndex, expertInnerComment, this.currentPatient._id);
    }

    deletePatient = async () => {
        await DayadaRequester.deletePatient(this.currentPatient._id);
        this.currentPatient = null;
    }

    setCommentFiles = async (newFileObjects, questionIndex) => {
        this.currentPatient = await DayadaRequester.setCommentFiles(newFileObjects, questionIndex, this.currentPatient._id);
    }

    removeRecommendationFile = async (fileIndex, category) => {
        this.currentPatient = await DayadaRequester.removeRecommendationFile(fileIndex, category, this.currentPatient._id);
    }

    setRecommendationFiles = async (newFileObjects, category) => {
        this.currentPatient = await DayadaRequester.setRecommendationFiles(newFileObjects, category, this.currentPatient._id);
    }

    updateRecommendationText = async (text, category) => {
        this.currentPatient = await DayadaRequester.updateRecommendationText(text, category, this.currentPatient._id);
    }

    removeCommentFile = async (fileIndex, questionIndex) => {
        this.currentPatient = await DayadaRequester.removeCommentFile(fileIndex, questionIndex, this.currentPatient._id);
    }
}
